var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"layout"}},[_c('el-container',[_c('el-header',{staticStyle:{"height":"80px"}},[_c('Header')],1),_c('el-container',{staticClass:"tableleft"},[_c('el-main',[_c('router-view')],1)],1),_c('el-footer',[_c('Footer')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }